<template>
  <noticePc v-if="!isMobile"></noticePc>
  <noticeM v-else></noticeM>
</template>
<script>
import noticePc from './notice-pc'
import noticeM from './notice-m'
import { mapState } from 'vuex'
export default {
  components: {
    noticePc,
    noticeM
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  }
}
</script>
<style lang="scss">
</style>
